import cx from 'classnames2';
import React from 'react';

import defaultStyles from './Tooltip.scss';

export type TooltipPositions = 'n' | 'ne' | 'nw' | 's' | 'se' | 'sw' | 'w' | 'e';

export interface ITooltip {
  position: TooltipPositions;
  multiline: boolean;
  noDelay: boolean;
  visible: boolean;
}

export interface IHasTooltip {
  tooltipText?: string;
  tooltipPosition?: TooltipPositions;
  tooltipVisible?: boolean;
}

export const mapPropsToStyles = (style, props) => {
  return {
    [style.tooltip]: props.tooltip,
    [style.sticky]: props.visible,
    [style[`tooltip-${props.position}`]]: props.position,
    [style.multiline]: props.multiline,
    [style['no-delay']]: props.noDelay
  };
};

export const Tooltip: React.FC<any> = props => {
  const { style = defaultStyles } = props;
  const classes = mapPropsToStyles(style, props);

  return (
    <span className={cx(style.tooltip, classes)} aria-label={props.label}>
      {props.children}
    </span>
  );
};

Tooltip.defaultProps = {
  position: 'n'
};
